import React from 'react';
import { useDispatch } from 'react-redux';
import { camera } from '../../../../../../../../../../shared/assets/emojis';

import { Button, Emoji } from 'hosman-material';
import { updateStep } from '../../../../../../../../../reducers/SellerApp/photoMeetingsSlice';

const Introduction = () => {
  const dispatch = useDispatch();

  return (
    <div className='flex flex-col gap-12 text-ih-indigo'>
      <div className='flex flex-col gap-3 items-center'>
        <Emoji emojiSrc={camera} width='w-9' />  
        <p className='h3 text-ih-indigo'>Réservation du reportage photo</p>
      </div>

      <div className='flex justify-center gap-3'>
        <Button label='Démarrer' onClick={() => dispatch(updateStep('Diagnostics'))} />
      </div>
    </div>
  )
}

export default Introduction;
